module.exports = {
      id: "fb-blue-usage",
      viewBox: "0 0 28 27.83",
      url: "/" + "svg-sprite-475344759687326ca60b708b4aa20d33.svg#fb-blue",
      toString: function () {
        return this.url;
      }
    }